import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import PromoCode from 'pages/promo-code'
import { PAGES } from 'routes/index'

export const promoCodeRoutes: RouteObject[] = [
  {
    path: PAGES.PROMO_CODE,
    element: (
      <PrivateRoute feature={FEATURE.PROMO_CODE}>
        <PromoCode />
      </PrivateRoute>
    ),
  },
]
